import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { InventoryLayout } from "@/screens/Inventory/components"
import { uomLoader } from "@/screens/Inventory/loaders"

export const Route = createFileRoute("/app/inventory/_layout")({
  loader: uomLoader,
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.INVENTORY_VIEW]}>
      <InventoryLayout />
    </PermissionContentWrapper>
  ),
})
